<template>
  <div class="preview-card">
    <slot name="header"></slot>
    <div class="card-content">
      <div v-if="lastUpdated" class="last-updated">
        情報更新日時：{{ lastUpdated }}
      </div>

      <slot name="content" class="container-wrapper"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviewCard",
  props: {
    lastUpdated: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.preview-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  border-radius: 6px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  background: #ffffff;
  overflow: hidden;

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-self: stretch;
    padding: 24px;

    .last-updated {
      align-self: stretch;
      color: #4f4f4f;
      text-align: right;
      font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
    }
  }
}
</style>
